import * as React from 'react';

const SvgComponent = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 390 390"
    style={{
      enableBackground: 'new 0 0 390 390'
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="M23.6 195c0-47.3 19.2-90.2 50.2-121.2L57.1 57.1C20.3 93.9 0 142.9 0 195c0 52.1 20.3 101.1 57.1 137.9l16.7-16.7c-31-31-50.2-73.9-50.2-121.2zM366.4 195c0 47.3-19.2 90.2-50.2 121.2l16.7 16.7C369.7 296 390 247.1 390 195c0-52.1-20.3-101-57.1-137.9l-16.7 16.7c31 31 50.2 73.9 50.2 121.2z" />
    <path d="M90.3 195c0-28.9 11.7-55.1 30.7-74l-18-18c-23.6 23.6-38.2 56.1-38.2 92s14.6 68.4 38.2 92l17.9-17.9c-18.9-19-30.6-45.2-30.6-74.1zM299.7 195c0 28.9-11.7 55.1-30.7 74l18 18c23.6-23.6 38.2-56.1 38.2-92s-14.6-68.4-38.2-92l-17.9 17.9c18.9 19 30.6 45.2 30.6 74.1z" />
    <circle cx={195} cy={195} r={63} />
  </svg>
);

export default SvgComponent;
